<script>
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import Notifier from "../stores/notifier";
    import {formatDate, scrollTo} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import Pagination from "../components/Pagination.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";

    const tableColumns = [
        {key: 'code', title: 'ΚΩΔΙΚΟΣ', sortable: true},
        {key: 'lastname', title: 'ΟΝΟΜΑ', sortable: true, sort_way: 'ASC'},
        {key: 'phone', title: 'ΤΗΛΕΦΩΝΟ', sortable: false, class: 'hidden-xs'},
        {key: 'email', title: 'EMAIL', sortable: true, class: 'hidden-xs'},
        {key: 'afm', title: 'ΑΦΜ', sortable: true, class: 'hidden-xs'},
        {key: 'region_id', title: 'ΝΟΜΟΣ', sortable: true, class: 'hidden-xs'},
        {key: 'city', title: 'ΠΟΛΗ', sortable: true, class: 'hidden-xs'},
        {key: 'expires_at', title: 'ΣΥΝΔΡ.', sortable: true, class: 'hidden-xs'},
        {key: 'has_vote', title: 'ΨΗΦΙΣΕ', sortable: true, class: 'hidden-xs'},
    ];

    const itemsPerPage = [20, 50, 100, 500, 1000];

    let pageHeaderControls = [
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    let list = null;
    let totalMembers = null;
    let search = {
        code: null,
        afm: null,
        name: null,
        term: null,
        region_id: '',
        has_vote: '',
        limit: 50,
        offset: 0,
        sort_field: null,
        sort_way: null,
    };
    let page = 1;

    const load = (loader = LOADER.POPUP) => {
        const onSuccess = result => {
            list = result.list;
            totalMembers = ~~result.total;

            list.map(item => {
                if (!item.code) {
                    item.code = '';
                }
                if (!item.phone1) {
                    item.phone1 = '';
                }
                if (!item.last_subscription) {
                    item.last_subscription = '';
                }
                item.has_vote = ~~item.has_vote;
            });
        }

        const onFailure = err => {
        };

        search.offset = (page - 1) * search.limit;

        R.handle(R.member.index, search, onSuccess, onFailure, loader);
    }

    const onSearch = () => {
        page = 1;
        load();
    }

    const clearSearch = () => {
        search.code = null;
        search.afm = null;
        search.name = null;
        search.term = null;
        search.region_id = '';
        search.has_vote = '';
        search.offset = 0;
        page = 1;
        load();
    }

    const onColumnSort = ({detail}) => {
        search.sort_field = detail.key;
        search.sort_way = detail.sort_way;
        load();
    }

    const onPageChange = ({detail}) => {
        page = detail;
        load();
        scrollTo('listing-top', -50);
    }

    const initialize = () => {
        if (!list) {
            page = 1;
            search.limit = itemsPerPage[0];

            load(LOADER.PAGE);
        }
    }

    const onToggleVote = (member) => {
        const onSuccess = result => {
            member.has_vote = ~~result.has_vote;
            list = list;
            Notifier.showMessage(member.has_vote == 1 ? "Το μέλος έχει ψηφίσει" : "Το μέλος δεν έχει ψηφίσει");
        }

        const onFailure = err => {
        };

        let has_vote = member.has_vote == 1 ? 0 : 1;

        R.handle(R.member.setVote, {id: member.id, has_vote}, onSuccess, onFailure, LOADER.NONE);
    }

    initialize();
</script>

<PageHeader title="Εκλογές" controls={ pageHeaderControls } on:reload={ load }/>
<div class="panel panel-simple p-2 mb-5">
    <div class="row">
        <div class="col-xl-2 col-lg-2 col-md-3 form-group-sm">
            <select class="form-select" bind:value="{ search.has_vote }" on:change={ onSearch }>
                <option value="">Όλα τα μέλη</option>
                <option value="1">Ψήφισαν</option>
            </select>
        </div>
        <div class="col-xl-1 col-lg-2 col-md-2 form-group-sm">
            <input type="text" class="form-control" bind:value="{ search.code }" on:change={ onSearch }
                   placeholder="αρ. μητρώου">
        </div>
        <div class="col-xl-1 col-lg-2 col-md-7 form-group-lg form-group-md form-group-sm">
            <input type="text" class="form-control" bind:value="{ search.afm }" on:change={ onSearch }
                   placeholder="Α.Φ.Μ.">
        </div>
        <div class="col-xl-2 col-lg-6 col-md-4 form-group-sm">
            <input type="text" class="form-control" bind:value="{ search.name }" on:change={ onSearch }
                   placeholder="όνομα">
        </div>
        <div class="col-xl-2 col-lg-8 col-md-4 form-group-sm">
            <input type="text" class="form-control" bind:value="{ search.term }" on:change={ onSearch }
                   placeholder="τηλέφωνο ή email">
        </div>
        <div class="col-xl-2 col-lg-8 col-md-4 form-group-sm">
            <select class="form-select" bind:value="{ search.region_id }">
                <option value="">νομός</option>
                {#each $app.regions as region}
                    <option value="{ region.id }">{ region.name }</option>
                {/each}
            </select>
        </div>
        <div class="col-xl-1 col-lg-2 col-md-2 col-6">
            <button class="btn btn-default btn-block" on:click={ clearSearch }>ΚΑΘΑΡΙΣΜΟΣ</button>
        </div>
        <div class="col-xl-1 col-lg-2 col-md-2 col-6">
            <button class="btn btn-outline btn-block" on:click={ onSearch }>ΕΥΡΕΣΗ</button>
        </div>
    </div>
</div>

<div class="row align-items-center mb-4" id="listing-top">
    <div class="col-xl-2 col-lg-3 col-md-4 col-7">
        <select class="form-select form-select-sm" bind:value="{ search.limit }" on:change="{ onSearch }">
            {#each itemsPerPage as item}
                <option value="{ item }">εμφάνιση { item } / σελίδα</option>
            {/each}
        </select>
    </div>
    {#if list && list.length}
        <div class="col-xl-10 col-lg-9 col-md-8 col-5">
            <span class="listing-info">Μέλη: <strong>{ totalMembers }</strong></span>
            <span class="listing-info hidden-xs">Σελίδα: <strong>{ page }</strong></span>
        </div>
    {/if}
</div>

{#if list}
    {#if list.length}
        <table class="table table-list members-list table-list-border mb-4">
            <TableHeader {tableColumns} on:sort={ onColumnSort }/>
            <tbody>
            {#each list as item}
                <tr class="row-hover" class:has-vote={ item.has_vote == 1 }>
                    <td class="code">
                        { item.code }
                    </td>
                    <td>
                        { item.name }
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.phone1 }
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.email }
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.afm }
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.region_name }
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.city }
                    </td>
                    <td class="year-column text-gray text-center hidden-xs">
                        { formatDate(item.expires_at, 'y') }
                    </td>
                    <td class="year-column text-gray">
                        <Checkbox checked={ item.has_vote } on:change={ () => onToggleVote(item) }/>
                    </td>
                </tr>
            {/each}
            </tbody>
        </table>
        <Pagination itemsPerPage="{ search.limit }" totalItems="{ totalMembers }" page="{ page }"
                    on:change="{ onPageChange }"/>
    {:else}
        <div class="panel-simple panel-pad">
            Δεν βρέθηκαν μέλη.
        </div>
    {/if}
{/if}


<style>
    .members-list .code {
        width: 60px;
    }

    .members-list .has-vote {
        background: rgba(0, 255, 0, 0.2);
    }
</style>